<template>
    <div class="hero-banner" :style="{
      'background-image': 'url(' + image + ')',
    }">
      <slot></slot>
    </div>
</template>

<script>

export default {
  name: 'hero-banner',
  props: {
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.hero-banner {
  min-height: 600px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: $mobile-max) {
   min-height: 400px;
  }
}
</style>
